<template>
    <b-container id="tasks-container" fluid>

        <div id="tabs">
            <ul>
                <li @click="selectedTab = 'date'">
                    <a href="#tabs-date"><i class="fas fa-calendar-day"></i> Data</a>
                </li>
                <li @click="selectedTab = 'protocol'">
                    <a href="#tabs-protocol"><i class="fas fa-hashtag"></i> Código da Tarefa</a>
                </li>
                <li @click="selectedTab = 'ref_protocol'">
                    <a href="#tabs-ref-protocol"><i class="fas fa-link"></i> Protocolo do Atendimento</a>
                </li>
                <li @click="selectedTab = 'reason'">
                    <a href="#tabs-reason"><i class="fas fa-tag"></i> Motivo</a>
                </li>
                <li @click="selectedTab = 'status'">
                    <a href="#tabs-status"><i class="fas fa-tags"></i> Status</a>
                </li>
                <li @click="selectedTab = 'priority'">
                    <a href="#tabs-priority"><i class="fas fa-bullseye"></i> Prioridade</a>
                </li>
                <li @click="selectedTab = 'owner_user'">
                    <a href="#tabs-owner-user"><i class="fas fa-user"></i> Responsável</a>
                </li>
                <li @click="selectedTab = 'owner_group'">
                    <a href="#tabs-owner-group"><i class="fas fa-users"></i> Base (Grupo)</a>
                </li>
            </ul>

            <div class="row" id="filters">
                <div class="col-md-12" id="tabs-date">
                    <div v-if="selectedTab === 'date'" class="filter-group">
                        <div>
                            <label class="filter-select-label">Buscar por data de criação</label>
                        </div>
                        <div class="d-flex justify-content-center">
                            <div class="col">
                                <label>De:</label>
                                <input type="date" class="form-control" v-model="filters.startDate">
                            </div>
                            <div class="col">
                                <label>Até:</label>
                                <input type="date" class="form-control" v-model="filters.endDate">
                            </div>
                            <div class="col d-flex align-items-end">
                                <button type="button" class="btn btn-primary mb-0" @click="applyFilter">
                                    <i class="fas fa-search"></i> Buscar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" id="tabs-protocol">
                    <div v-if="selectedTab === 'protocol'" class="filter-group">
                        <div>
                            <label class="filter-select-label">Buscar por código da tarefa</label>
                        </div>
                        <div class="custom-input-group">
                            <input type="text" class="form-control" placeholder="🔎 Digite o protocolo da tarefa..."
                                v-model="filters.protocol" @keyup.enter="applyFilter">
                            <button type="button" class="btn btn-primary" @click="applyFilter">
                                <i class="fas fa-search"></i> Buscar
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" id="tabs-ref-protocol">
                    <div v-if="selectedTab === 'ref_protocol'" class="filter-group">
                        <div>
                            <label class="filter-select-label">Buscar por protocolo do atendimento</label>
                        </div>
                        <div class="custom-input-group">
                            <input type="text" class="form-control" placeholder="🔎 Digite o protocolo de referência..."
                                v-model="filters.refProtocol" @keyup.enter="applyFilter">
                            <button type="button" class="btn btn-primary" @click="applyFilter">
                                <i class="fas fa-search"></i> Buscar
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" id="tabs-reason">
                    <div v-if="selectedTab === 'reason'" class="filter-group">
                        <div>
                            <label class="filter-select-label">Buscar por motivo de acionamento</label>
                        </div>
                        <div class="custom-input-group">
                            <select class="form-control" style="width: 75% !important;" v-model="filters.reason">
                                <option value="" disabled>🔽 Selecione um motivo...</option>
                                <option v-for="r in reasonsList" :key="r._id" :value="r.name">{{ r.name }}</option>
                            </select>
                            <button type="button" class="btn btn-primary" @click="applyFilter">
                                <i class="fas fa-search"></i> Buscar
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" id="tabs-status">
                    <div v-if="selectedTab === 'status'" class="filter-group">
                        <div>
                            <label class="filter-select-label">Buscar por status</label>
                        </div>
                        <div class="custom-input-group">
                            <select class="form-control" style="width: 75% !important;" v-model="filters.status">
                                <option value="" disabled>🔽 Selecione um status...</option>
                                <option v-for="s in statusesList" :key="s._id" :value="s.name">{{ s.name }}</option>
                            </select>
                            <button type="button" class="btn btn-primary" @click="applyFilter">
                                <i class="fas fa-search"></i> Buscar
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" id="tabs-priority">
                    <div v-if="selectedTab === 'priority'" class="filter-group">
                        <div>
                            <label class="filter-select-label">Buscar por prioridade</label>
                        </div>
                        <div class="custom-input-group">
                            <select class="form-control" style="width: 75% !important;" v-model="filters.priority">
                                <option value="" disabled>🔽 Selecione uma prioridade...</option>
                                <option v-for="p in prioritiesList" :key="p._id" :value="p.name">{{ p.name }}</option>
                            </select>
                            <button type="button" class="btn btn-primary" @click="applyFilter">
                                <i class="fas fa-search"></i> Buscar
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" id="tabs-owner-user">
                    <div v-if="selectedTab === 'owner_user'" class="filter-group">
                        <div>
                            <label class="filter-select-label">Buscar por responsável</label>
                        </div>
                        <div class="custom-input-group">
                            <select class="form-control" style="width: 75% !important;" v-model="filters.ownerUser">
                                <option value="" disabled>🔽 Selecione um responsável...</option>
                                <option v-for="u in usersList" :key="u._id" :value="u.name">{{ u.name }}</option>
                            </select>
                            <button type="button" class="btn btn-primary" @click="applyFilter">
                                <i class="fas fa-search"></i> Buscar
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" id="tabs-owner-group">
                    <div v-if="selectedTab === 'owner_group'" class="filter-group">
                        <div>
                            <label class="filter-select-label">Buscar por base (grupo)</label>
                        </div>
                        <div class="custom-input-group">
                            <select class="form-control" style="width: 75% !important;" v-model="filters.ownerGroup">
                                <option value="" disabled>🔽 Selecione um base (grupo)...</option>
                                <option v-for="g in groupsList" :key="g._id" :value="g.name">{{ g.name }}</option>
                            </select>
                            <button type="button" class="btn btn-primary" @click="applyFilter">
                                <i class="fas fa-search"></i> Buscar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr>

        <b-row class="mb-2">
            <b-col md="auto" class="d-flex" style="gap: 15px;">
                <b-button variant="success" @click="generateExcel">
                    <i class="fas fa-file-excel"></i> Excel
                </b-button>

                <b-button variant="primary" @click="openCreate">
                    <i class="fas fa-plus"></i> Nova Tarefa
                </b-button>
            </b-col>

            <div class="col-md-6 ml-auto">
                <div class="mb-1" style="height: 100%;">
                    <div class="input-group input-group-sm" style="height: 100%;">
                        <div class="custom-control custom-switch mb-0 mr-2 mt-1" style="height: 100%;">
                            <input v-model="onlyOpen" type="checkbox" class="custom-control-input" id="only_open_switch" />
                            <label class="custom-control-label" for="only_open_switch"
                                :style="{ minWidth: '90px', whiteSpace: 'nowrap', color: onlyOpen ? '#1c869a' : 'inherit', fontWeight: onlyOpen ? '600' : 'normal' }">
                                {{ onlyOpen ? 'Exibindo tarefas abertas' : 'Exibindo todas tarefas' }}
                            </label>
                        </div>

                        <input v-model="filterText" type="search"
                            placeholder="Digite para filtrar os resultados..." class="filter-input form-control" style="height: 100%;" />
                    </div>
                </div>
            </div>
        </b-row>

        <b-row>
            <b-col md="12" style="overflow-x: auto;">
                <b-table striped hover bordered show-empty :items="tasks" :fields="fields" :per-page="0"
                    :no-local-sorting="true" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                    @sort-changed="onSortChanged" thead-class="font-weight-bold">
                    <template v-if="loading" #empty>
                        <div class="text-center">
                            <b-spinner variant="dark" small></b-spinner> Carregando...
                        </div>
                    </template>
                    <template v-else #empty>
                        <h6 class="text-center">Nenhuma tarefa encontrada.</h6>
                    </template>

                    <template #cell(reason)="{ item }">
                        <span v-if="item.reason" :class="{ 'itau-badge': item.is_itau }">
                            {{ item.reason }}{{ item.is_itau ? ' (Itaú)' : '' }}
                        </span>
                        <span v-else>—</span>
                    </template>

                    <template #cell(priority)="{ item }">
                        <span v-if="item.priority" class="highlight-badge" :style="dinamicStyle(item.priority.color)">
                            <small>({{ item.priority.level }})</small> {{ item.priority.name }}
                        </span>
                        <span v-else>—</span>
                    </template>

                    <template #cell(status)="{ item }">
                        <span v-if="item.status" class="highlight-badge" :style="dinamicStyle(item.status.color)">
                            {{ item.status.name }}
                        </span>
                        <span v-else>—</span>
                    </template>

                    <template #cell(owner_user)="{ item }">
                        {{ item.owner_user?.name ?? '—' }}
                    </template>

                    <template #cell(owner_group)="{ item }">
                        {{ item.owner_group?.name ?? '—' }}
                    </template>

                    <template #cell(channel)="{ item }">
                        <span v-html="formatChannel(item.channel)"></span>
                    </template>

                    <template #cell(sla)="{ item }">
                        <span v-html="handleTicketSLA(item, slaTick)"></span>
                    </template>

                    <template #cell(createdAt)="{ item }">
                        {{ formatDate(item.createdAt) }}
                    </template>

                    <template #cell(view-button)="{ item }">
                        <span class="view-button-wrapper">
                            <b-btn id="view-button" @click.prevent="showModalDetails(item)"
                                style="border-radius: 3px !important;">
                                <i class="far fa-eye" aria-hidden="true"></i>
                            </b-btn>
                        </span>
                    </template>
                </b-table>
            </b-col>
        </b-row>

        <b-row class="align-items-center mb-2">
            <b-col md="12">
                <p class="pagination-info-text mb-0">
                    Mostrando <strong>{{ paginationInfo.start }}</strong> a <strong>{{ paginationInfo.end }}</strong> de
                    <strong>{{ paginationInfo.total }}</strong> registros
                </p>
            </b-col>
        </b-row>

        <b-row class="justify-content-between">
            <b-col md="4">
                <b-form-group label="Registros por página" label-for="per-page-select" label-cols-md="6"
                    label-align-sm="right" label-size="sm" class="mb-0 align-self-center">
                    <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" />
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right" size="md"
                    class="my-0" />
            </b-col>
        </b-row>

        <TaskFormModal ref="formModal" :priorities-list="prioritiesList" :statuses-list="statusesList"
            :groups-list="groupsList" :users-list="usersList" :reasons-list="reasonsList" @saved="onSaved" />

        <TaskDetailsModal ref="detailsModal" modal-id="task-details-modal-manager" :priorities-list="prioritiesList"
            :users-list="usersList" :reasons-list="reasonsList" @updateTaskTable="onSaved" />

    </b-container>
</template>

<script>
import TaskFormModal from './TaskFormModal.vue';
import TaskDetailsModal from './TaskDetailsModal.vue';
import { dinamicStyle, formatDate, handleTicketSLA, handleTicketSLAExpirationDate } from '../../helpers/utils';
import { getTaskSocket } from './connections/taskSocketConnection.js';
import { taskManagerAxios } from './connections/taskApiConnection.js';
import * as XLSX from 'xlsx';

export default {
    name: 'TasksManager',
    components: { TaskFormModal, TaskDetailsModal },
    data() {
        return {
            loading: false,
            tasks: [],
            totalRows: 0,
            currentPage: 1,
            perPage: 15,
            pageOptions: [10, 15, 25, 50],
            sortBy: 'updatedAt',
            sortDesc: true,
            slaTick: 0,
            slaInterval: null,
            taskSocket: null,
            selectedTab: 'date',
            filterToRequest: null,
            filterText: '',
            filterTextDebounce: null,
            onlyOpen: undefined,
            filters: {
                startDate: '',
                endDate: '',
                protocol: '',
                refProtocol: '',
                reason: '',
                status: '',
                priority: '',
                ownerUser: '',
                ownerGroup: '',
            },
            prioritiesList: [],
            statusesList: [],
            groupsList: [],
            usersList: [],
            reasonsList: [],
            fields: [
                { key: 'view-button', label: 'Visualizar', class: 'text-center align-middle', thStyle: { backgroundColor: '#1c869a', color: '#fff', width: '100px' } },
                { key: 'reason', label: 'Motivo', sortable: true, class: 'text-center align-middle', thStyle: { backgroundColor: '#1c869a', color: '#fff' } },
                { key: 'client_name', label: 'Cliente', sortable: true, class: 'text-center align-middle', thStyle: { backgroundColor: '#1c869a', color: '#fff' } },
                { key: 'address', label: 'Endereço', sortable: true, class: 'text-center align-middle', thStyle: { backgroundColor: '#1c869a', color: '#fff' } },
                { key: 'protocol', label: 'Código da Tarefa', sortable: true, class: 'text-center align-middle', thStyle: { backgroundColor: '#1c869a', color: '#fff' } },
                { key: 'ref_protocol', label: 'Protocolo do Atendimento', sortable: true, class: 'text-center align-middle', thStyle: { backgroundColor: '#1c869a', color: '#fff' } },
                { key: 'priority', label: 'Prioridade', sortable: false, class: 'text-center align-middle', thStyle: { backgroundColor: '#1c869a', color: '#fff' } },
                { key: 'status', label: 'Status', sortable: false, class: 'text-center align-middle', thStyle: { backgroundColor: '#1c869a', color: '#fff' } },
                { key: 'owner_user', label: 'Responsável', sortable: false, class: 'text-center align-middle', thStyle: { backgroundColor: '#1c869a', color: '#fff' } },
                { key: 'owner_group', label: 'Base (Grupo)', sortable: false, class: 'text-center align-middle', thStyle: { backgroundColor: '#1c869a', color: '#fff' } },
                { key: 'channel', label: 'Canal', sortable: true, class: 'text-center align-middle', thStyle: { backgroundColor: '#1c869a', color: '#fff' } },
                { key: 'sla', label: 'SLA', sortable: false, class: 'text-center align-middle', thStyle: { backgroundColor: '#1c869a', color: '#fff' } },
                { key: 'createdAt', label: 'Criação', sortable: true, class: 'text-center align-middle', thStyle: { backgroundColor: '#1c869a', color: '#fff' } },
            ],
        };
    },
    computed: {
        paginationInfo() {
            const start = this.totalRows > 0 ? (this.currentPage - 1) * this.perPage + 1 : 0;
            const end = Math.min(this.currentPage * this.perPage, this.totalRows);
            return { start, end, total: this.totalRows };
        },
    },
    created() {
        const params = new URLSearchParams(window.location.search);
        const protocol = params.get('protocol');
        if (protocol) {
            this.filters.protocol = protocol;
            this.selectedTab = 'protocol';
            this.filterToRequest = 'protocol';
            this._activateProtocolTab = true;
        }
        this.fetchTasks();
        this.fetchMeta();
    },
    mounted() {
        this.slaInterval = setInterval(() => { this.slaTick++; }, 60000);
        this.taskSocket = getTaskSocket();
        this.taskSocket.on('task.created', this.onTaskCreated);
        this.taskSocket.on('task.updated', this.onTaskUpdated);
        this.taskSocket.on('task.notification', this.onTaskNotification);
        this.taskSocket.on('task.closed', this.onTaskClosed);
        if (this._activateProtocolTab) {
            setTimeout(() => {
                $('#tabs').tabs('option', 'active', 1);
            }, 1);
        }
    },
    beforeDestroy() {
        if (this.slaInterval) clearInterval(this.slaInterval);
        if (this.taskSocket) {
            this.taskSocket.off('task.created', this.onTaskCreated);
            this.taskSocket.off('task.updated', this.onTaskUpdated);
            this.taskSocket.off('task.notification', this.onTaskNotification);
            this.taskSocket.off('task.closed', this.onTaskClosed);
        }
    },
    methods: {
        dinamicStyle,
        formatDate,
        handleTicketSLA,
        handleTicketSLAExpirationDate,
        applyFilter() {
            this.filterToRequest = this.selectedTab;
            this.filterText = '';
            this.currentPage === 1 ? this.fetchTasks() : (this.currentPage = 1);
        },
        resetFilters() {
            this.filters = {
                startDate: '',
                endDate: '',
                protocol: '',
                refProtocol: '',
                reason: '',
                status: '',
                priority: '',
                ownerUser: '',
                ownerGroup: '',
            };
            this.filterToRequest = null;
        },
        buildFilterParams() {
            if (this.filterText) return { search: this.filterText };
            const startDate = this.filters.startDate ? `${this.filters.startDate} 00:00:00` : null;
            const endDate = this.filters.endDate ? `${this.filters.endDate} 23:59:59` : null;

            switch (this.filterToRequest) {
                case 'date': return { startDate, endDate };
                case 'protocol': return { protocol: this.filters.protocol || null };
                case 'ref_protocol': return { ref_protocol: this.filters.refProtocol || null };
                case 'reason': return { reason: this.filters.reason || null };
                case 'status': return { search: this.filters.status || null };
                case 'priority': return { search: this.filters.priority || null };
                case 'owner_user': return { search: this.filters.ownerUser || null };
                case 'owner_group': return { search: this.filters.ownerGroup || null };
                default: return {};
            }
        },
        async fetchTasks() {
            this.loading = true;
            try {
                const { data } = await taskManagerAxios.get('/tasks', {
                    params: {
                        page: this.currentPage,
                        perPage: this.perPage,
                        sortBy: this.sortBy,
                        sortDesc: this.sortDesc,
                        onlyOpen: this.onlyOpen ? true : undefined,
                        ...this.buildFilterParams(),
                    },
                });
                this.tasks = data.data ?? [];
                this.totalRows = data.total ?? 0;
            } catch (error) {
                console.error('[TasksManager] fetchTasks:', error);
            } finally {
                this.loading = false;
            }
        },
        async fetchMeta() {
            try {
                const [priorities, statuses, groups, users, reasons] = await Promise.all([
                    taskManagerAxios.get('/priorities'),
                    taskManagerAxios.get('/statuses'),
                    taskManagerAxios.get('/groups'),
                    taskManagerAxios.get('/users'),
                    taskManagerAxios.get('/reasons'),
                ]);
                this.prioritiesList = priorities.data ?? [];
                this.statusesList = statuses.data ?? [];
                this.groupsList = groups.data ?? [];
                this.usersList = users.data ?? [];
                this.reasonsList = reasons.data ?? [];
            } catch (error) {
                console.error('[TasksManager] fetchMeta:', error);
            }
        },
        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.currentPage === 1 ? this.fetchTasks() : (this.currentPage = 1);
        },
        openCreate() {
            this.$refs.formModal.open();
        },
        async generateExcel() {
            try {
                Swal.fire({
                    title: "Exportando...",
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    html: '<div class="d-flex justify-content-center my-3"><i class="fa fa-spinner fa-spin fa-3x"></i></div><p>Gerando arquivo Excel, aguarde...</p>',
                });
                const { data } = await taskManagerAxios.get('/tasks', {
                    params: {
                        all: true,
                        sortBy: this.sortBy,
                        sortDesc: this.sortDesc,
                        onlyOpen: this.onlyOpen ? true : undefined,
                        ...this.buildFilterParams(),
                    },
                });
                Swal.close();
                const items = Array.isArray(data) ? data : [];
                if (items.length < 1) {
                    Swal.fire({ type: 'info', text: 'Nenhum registro encontrado para exportar!' });
                    return;
                }

                // Coletar todos os group_ids únicos do service_history
                const uniqueGroupIds = new Set();
                items.forEach(item => {
                    if (Array.isArray(item.service_history)) {
                        item.service_history.forEach(sh => {
                            if (sh.group_id) uniqueGroupIds.add(sh.group_id);
                        });
                    }
                });

                // Criar mapeamento de group_id para nome do grupo
                const groupIdToName = {};
                this.groupsList.forEach(g => {
                    groupIdToName[g._id] = g.name;
                });

                const rows = items.map(item => {
                    const row = {
                        'Código da tarefa': item?.protocol ?? '',
                        'Protocolo do atendimento': item?.ref_protocol ?? '',
                        'Motivo': item?.reason ?? '',
                        'Tipo de serviço': item?.service_type ?? '',
                        'Cliente': item?.client_name ?? '',
                        'Endereço': item?.address ?? '',
                        'Canal': item?.channel ?? '',
                        'Prioridade': item?.priority?.name ?? '',
                        'Status': item?.status?.name ?? '',
                        'Responsável': item?.owner_user?.name ?? '',
                        'Base (Grupo)': item?.owner_group?.name ?? '',
                        'Vencimento SLA': item?.started_at && item?.sla ? handleTicketSLAExpirationDate(item) : '',
                        'Criado por': item?.created_by?.user?.name ?? '',
                        'Criação': this.formatDate(item?.createdAt),
                        'Finalizado em': item?.closed_at ? this.formatDate(item.closed_at) : '',
                        'Finalizado por': item?.closed_by?.name ?? '',
                        'Dentro do prazo': this.checkFinishedOnTime(item),
                    };

                    // Adicionar colunas de service_history para cada grupo
                    uniqueGroupIds.forEach(groupId => {
                        const groupName = groupIdToName[groupId] || groupId;
                        const colName = `Tempo em ${groupName}`;
                        const serviceEntry = item.service_history?.find(sh => sh.group_id === groupId);
                        row[colName] = serviceEntry ? this.convertSecondsToHHMMSS(serviceEntry.time) : '';
                    });

                    return row;
                });

                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.json_to_sheet(rows);
                XLSX.utils.book_append_sheet(wb, ws, 'Tarefas');
                XLSX.writeFile(wb, 'tarefas.xlsx');
            } catch (error) {
                Swal.close();
                console.error(error);
                Swal.fire({ type: 'error', text: 'Erro ao exportar Excel!' });
            }
        },
        convertSecondsToHHMMSS(seconds) {
            if (!seconds || seconds < 0) return '00:00:00';
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const secs = Math.floor(seconds % 60);
            return [hours, minutes, secs].map(v => String(v).padStart(2, '0')).join(':');
        },
        checkFinishedOnTime(task) {
            const slaExpirationDate = this.handleTicketSLAExpirationDate(task);
            if (slaExpirationDate === '-') return 'NÃO';
            const expireAt = moment(slaExpirationDate, 'DD/MM/YYYY HH:mm:ss');
            if (task.closed_at) {
                const closedAt = moment(task.closed_at);
                return closedAt.isBefore(expireAt) || closedAt.isSame(expireAt) ? 'SIM' : 'NÃO';
            }

            const now = moment();
            return now.isBefore(expireAt) || now.isSame(expireAt) ? 'SIM' : 'NÃO';
        },
        async showModalDetails(task) {
            try {
                if (!task.comments || !task.timeline) {
                    Swal.fire({
                        title: "Carregando dados da tarefa.",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        showConfirmButton: false,
                        html: '<div class="d-flex justify-content-center my-3"><i class="fa fa-spinner fa-spin fa-3x"></i></div><p>Por favor, aguarde...</p>',
                    });
                    const { data } = await taskManagerAxios.get(`/tasks/${task._id}`);
                    if (!data) {
                        Swal.fire({ type: "error", text: "Falha ao obter detalhes da tarefa!" });
                        return;
                    }
                    task.comments = data.comments ?? [];
                    task.timeline = data.timeline ?? [];
                }
                Swal.close();
                this.$refs.detailsModal.openModal(task);
            } catch (error) {
                Swal.close();
                console.error(error);
                Swal.fire({ type: "error", text: "Falha ao obter detalhes da tarefa!" });
            }
        },
        formatChannel(channel) {
            if (channel === 'whatsapp') return 'Whatsapp';
            if (channel === 'telefone') return 'Telefone';
            if (channel === 'phone') return 'Telefone';
            if (channel === 'email') return 'E-mail';
            return channel;
        },
        onSaved(task) {
            const idx = this.tasks.findIndex(t => t._id === task._id);
            if (idx !== -1) {
                this.$set(this.tasks, idx, task);
            } else {
                this.tasks.unshift(task);
                this.totalRows++;
            }
        },
        onTaskNotification(task) {
            const idx = this.tasks.findIndex(t => t._id === task._id);
            if (idx !== -1) this.$set(this.tasks, idx, task);
            if (task.new_notification?.high === true) this.playNotificationSound();
        },
        onTaskCreated(task) {
            if (this.tasks.find(t => t._id === task._id)) return;
            if (this.onlyOpen && task.closed_at) return;
            this.tasks.unshift(task);
            this.tasks.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
            if (this.tasks.length > this.perPage) this.tasks.pop();
            this.totalRows++;
            if (task.new_notification?.high === true) this.playNotificationSound();
        },
        onTaskUpdated(task) {
            const idx = this.tasks.findIndex(t => t._id === task._id);
            if (task.closed_at && this.onlyOpen) {
                if (idx !== -1) {
                    this.tasks.splice(idx, 1);
                    this.totalRows = Math.max(0, this.totalRows - 1);
                }
                return;
            }
            if (idx !== -1) this.$set(this.tasks, idx, task);
        },
        onTaskClosed(task) {
            const taskWithClosed = { ...task, closed_at: task.closed_at ?? new Date().toISOString() };
            const idx = this.tasks.findIndex(t => t._id === taskWithClosed._id);
            if (this.onlyOpen) {
                if (idx !== -1) {
                    this.tasks.splice(idx, 1);
                    this.totalRows = Math.max(0, this.totalRows - 1);
                }
                return;
            }
            if (idx !== -1) this.$set(this.tasks, idx, taskWithClosed);
        },
        playNotificationSound() {
            try {
                const audio = new Audio('/sounds/task-notification.mp3');
                audio.play();
            } catch (e) {
                console.warn('[TasksManager] playNotificationSound:', e);
            }
        },
        onTaskDeleted(id) {
            const before = this.tasks.length;
            this.tasks = this.tasks.filter(t => t._id !== id);
            if (this.tasks.length < before) this.totalRows = Math.max(0, this.totalRows - 1);
        },
    },
    watch: {
        selectedTab() {
            this.resetFilters();
        },
        filterText() {
            this.filterToRequest = null;
            clearTimeout(this.filterTextDebounce);
            this.filterTextDebounce = setTimeout(() => {
                this.currentPage === 1 ? this.fetchTasks() : (this.currentPage = 1);
            }, 500);
        },
        currentPage() {
            this.fetchTasks();
        },
        perPage() {
            this.currentPage === 1 ? this.fetchTasks() : (this.currentPage = 1);
        },
        onlyOpen() {
            this.currentPage === 1 ? this.fetchTasks() : (this.currentPage = 1);
        },
    },
}
</script>

<style scoped>
#tasks-container {
    margin: 10px;
}

.btn-header-table {
    margin-left: 1px;
}

.custom-input-group {
    display: flex;
    height: 5em;
    justify-content: center;
    align-items: center;
}

.filter-group {
    display: flex;
    flex-direction: column;
    margin: 0px;
}

.filter-group input {
    width: 70%;
    margin: 5px;
}

.filter-group button {
    margin: 5px;
    height: 2.5em;
    border-radius: 5px !important;
}

.filter-select-label {
    font-weight: bold;
    font-size: 18px;
    align-self: center;
}

.itau-badge {
    background-color: #EC7000;
    color: #ffffff;
    font-weight: bold;
    padding: 3px 10px;
    border-radius: 4px;
}

.highlight-badge {
    padding: 4px 10px;
    border-radius: 5px;
    font-weight: bold;
    font-size: 12px;
}

.highlight-badge small {
    font-size: 10px;
}

.pagination-info-text {
    font-size: 14px;
    color: #495057;
    text-align: center;
    padding: 10px 0;
}

.view-button-wrapper {
    position: relative;
    display: inline-block;
}

#view-button {
    background: none;
    border: none;
    padding: 0;
    box-shadow: none;
    outline: none;
}

#view-button i {
    color: #1c869a;
    font-size: 22px;
}

#view-button i:hover {
    color: #31bdda;
    transition: 0.5s;
}

.filter-input {
    height: 100% !important;
}
</style>
